import { Bell, Check, CheckCheck } from "lucide-react";
import { useState } from "react";
import { PeriodFilter } from "../components/PeriodFilter";
import { Button, Card, Spinner } from "../components/ui";
import { useMarkAllRead, useMarkNotificationRead, useNotifications, type Period } from "../lib/hooks";

export function NotificationsPage(): JSX.Element {
  const [period, setPeriod] = useState<Period>({});
  const { data: notifications, isLoading } = useNotifications(period);
  const markRead = useMarkNotificationRead();
  const markAll = useMarkAllRead();
  const hasUnread = (notifications ?? []).some((n) => !n.readAt);

  if (isLoading) return <Spinner />;

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-2xl font-bold text-brand-500">Notifications</h1>
        <div className="flex items-center gap-2">
          <PeriodFilter value={period} onChange={setPeriod} />
          <Button variant="ghost" disabled={!hasUnread || markAll.isPending} onClick={() => markAll.mutate()}>
            <CheckCheck size={16} /> Mark all read
          </Button>
        </div>
      </div>
      <Card>
        {notifications && notifications.length > 0 ? (
          <ul className="divide-y divide-slate-100">
            {notifications.map((n) => (
              <li key={n.id} className="flex items-start gap-3 py-3">
                <div
                  className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
                    n.readAt ? "bg-slate-100 text-slate-400" : "bg-accent-500/15 text-accent-600"
                  }`}
                >
                  <Bell size={16} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-slate-800">{n.title}</p>
                  <p className="text-sm text-slate-500">{n.body}</p>
                  <p className="mt-0.5 text-xs text-slate-400">
                    {new Date(n.createdAt).toLocaleString()}
                  </p>
                </div>
                {!n.readAt && (
                  <Button variant="ghost" onClick={() => markRead.mutate(n.id)} title="Mark read">
                    <Check size={16} />
                  </Button>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-slate-500">You're all caught up. 🎉</p>
        )}
      </Card>
    </div>
  );
}
